import { useEffect, useState } from "react";
import { useT } from "../../i18n/I18nProvider";
import { Button } from "../../ui/Button";

/** Browser full screen is independent of the authenticated POS lock. Esc never unlocks POS. */
export function PosFullscreen() {
  const t = useT();
  const [active, setActive] = useState(() => Boolean(document.fullscreenElement));
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    const changed = () => setActive(Boolean(document.fullscreenElement));
    document.addEventListener("fullscreenchange", changed);
    return () => document.removeEventListener("fullscreenchange", changed);
  }, []);
  if (!document.fullscreenEnabled) return null;
  return <div className="cc-pos-fullscreen">
    <Button onClick={() => {
      setFailed(false);
      void (document.fullscreenElement ? document.exitFullscreen() : document.documentElement.requestFullscreen())
        .catch(() => setFailed(true));
    }}>{t(active ? "pos.register.windowed" : "pos.register.fullscreen")}</Button>
    {failed ? <span role="alert">{t("pos.register.fullscreenFailed")}</span> : null}
  </div>;
}
